export const isMlsRestrictedTenant = (tenant) => {
  if (!tenant) return false;
  return Boolean(
    tenant.mlsRestricted ||
      tenant.auth?.requiresLogin ||
      tenant.auth?.saml?.enabled,
  );
};
